import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import SpareCapacityCriteria from "./SpareCapacityCriteria";
import { ReportCategory } from "../ReportCategory";

@NeoReport("SpareCapacity", { category: ReportCategory.IssuerReports })
export default class SpareCapacityReport extends Report<SpareCapacityCriteria> {

    constructor() {
        super(SpareCapacityCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
        </div>;
    }
}